<div class="custom-modal">
  <div class="header">
    <h1 mat-dialog-title>
      {{titulo}}
    </h1>
    <mat-icon mat-dialog-close="cancel">close</mat-icon>
  </div>
  <mat-divider></mat-divider>
  <mat-progress-bar color="primary" mode="indeterminate" [hidden]="!isLoading"></mat-progress-bar>
  <mat-card [hidden]="isLoading">
    <mat-card-header class="header-padrao">
      <mat-card-title>
        <div class="row">
          <div class="col">
            <div mat-dialog-content>
              <div [innerHTML]="texto" class="mb-3"></div>
              <table id="resumoLoteGerado" mat-table [dataSource]="gridResumoLoteGerado" class="table-sm">
                <ng-container matColumnDef="descricao">
                  <th mat-header-cell *matHeaderCellDef>Descrição</th>
                  <td mat-cell *matCellDef="let gridResumoLoteGerado">
                    Lote: {{ gridResumoLoteGerado.numeroLote }} - {{ gridResumoLoteGerado.qtdeCTes }} - CT-e(s) - {{
                    gridResumoLoteGerado.clienteNome }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="totalFrete">
                  <th mat-header-cell *matHeaderCellDef>Total do Frete</th>
                  <td mat-cell *matCellDef="let gridResumoLoteGerado">
                    {{ gridResumoLoteGerado.totalFrete | currency: 'BRL' }}
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              </table>
            </div>
          </div>
        </div>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="d-flex flex-column align-items-center" mat-dialog-actions>
        <a (click)="close()" class="mt-3 mb-3" style="cursor:pointer;">Ao fechar, você será direcionado para a página de acompanhamento dos lotes</a>
        <div>
          <button mat-flat-button (click)="close()" style="background-color: #cddc39">
            {{textoOk}}
          </button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
